module.exports = __webpack_public_path__ + "img/female2.18fca7f6.jpg";